import clsx from 'clsx';
import styles from './TypeSelector.module.scss';

function TypeSelector({ options = [], selectedOptionId, changeSelectedOption, testId }: any) {
    return (
        <div className={styles.TypeSelector} data-testid={testId}>
            {options.map((option: any) => {
                const isSelected = option.id === selectedOptionId;
                const iconUrl = isSelected ? option.iconSelected ?? option.icon : option.icon;
                return (
                    <div
                        className={clsx(styles.Option, { [styles.SelectedOption]: isSelected })}
                        key={option.id}
                        role="button"
                        tabIndex={0}
                        aria-pressed={isSelected}
                        onClick={() => changeSelectedOption(option.id)}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                changeSelectedOption(option.id);
                            }
                        }}
                    >
                        {!!iconUrl && <img src={iconUrl} alt="" className={styles.Icon} />}
                        {option.label}
                    </div>
                );
            })}
        </div>
    );
}

export default TypeSelector;
